/* Six Gun Chili: one-click cart drawer add-ons (works with Dawn's cart drawer) */
(function () {
  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-sgc-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Addin\u2019\u2026';
    try {
      var sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      var res = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.sgcAdd), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      }
    } catch (err) {
      console.error('[SGC add-on]', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = label;
    }
  });
})();
